/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for an org admin to register a standalone remote_session_client in Client ID Metadata Document (CIMD) mode under an existing issuer, with no user_session_issuer attachments. Speakeasy generates the client_id and hosts the metadata document; the issuer must advertise client_id_metadata_document_supported.
 */
export type CreateCimdOrganizationRemoteSessionClientForm = {
  /**
   * Optional upstream OAuth audience to send on the authorize redirect and token exchange.
   */
  audience?: string | undefined;
  /**
   * Owning project id for the new client; the project must belong to the caller's organization. Omit to inherit a project-specific issuer's project, or to create an organization-level client (no project, attachable by every project) under an organization-level issuer.
   */
  projectId?: string | undefined;
  /**
   * The owning remote_session_issuer id; must belong to the caller's organization and advertise client_id_metadata_document_supported.
   */
  remoteSessionIssuerId: string;
  /**
   * Explicit upstream OAuth scopes the dance should request for this client. Omit to fall back to the issuer's scopes_supported.
   */
  scope?: Array<string> | undefined;
};

/** @internal */
export type CreateCimdOrganizationRemoteSessionClientForm$Outbound = {
  audience?: string | undefined;
  project_id?: string | undefined;
  remote_session_issuer_id: string;
  scope?: Array<string> | undefined;
};

/** @internal */
export const CreateCimdOrganizationRemoteSessionClientForm$outboundSchema:
  z.ZodMiniType<
    CreateCimdOrganizationRemoteSessionClientForm$Outbound,
    CreateCimdOrganizationRemoteSessionClientForm
  > = z.pipe(
    z.object({
      audience: z.optional(z.string()),
      projectId: z.optional(z.string()),
      remoteSessionIssuerId: z.string(),
      scope: z.optional(z.array(z.string())),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectId: "project_id",
        remoteSessionIssuerId: "remote_session_issuer_id",
      });
    }),
  );

export function createCimdOrganizationRemoteSessionClientFormToJSON(
  createCimdOrganizationRemoteSessionClientForm:
    CreateCimdOrganizationRemoteSessionClientForm,
): string {
  return JSON.stringify(
    CreateCimdOrganizationRemoteSessionClientForm$outboundSchema.parse(
      createCimdOrganizationRemoteSessionClientForm,
    ),
  );
}
